import { useMutation, useQuery } from '@tanstack/react-query';
import React, { useEffect, useState } from 'react';
import { IoIosRecording } from 'react-icons/io';
import { PiPhoneCallThin } from 'react-icons/pi';
import { useRecoilState } from 'recoil';
import styled from 'styled-components';
import { inboundToggleRecoil } from '../sip-recoil/sipRecoil';
import { getInboundStatus, putInboundStatus } from '../sipApi/sipApi';

const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  width: 7.2rem;
  height: 3.2rem;
  background: #eee;
  border-radius: 3rem;
  /* padding: 0.8rem; */
  cursor: pointer;
  box-shadow: inset 0 0 8px rgba(0, 0, 0, 0.1);
`;

const ToggleIndicator = styled.div<{ $mode: 'ARS' | 'CALL' | null }>`
  position: absolute;
  width: 3.6rem;
  height: 3.2rem;
  border-radius: 3rem;
  transition:
    left 0.3s ease-in-out,
    background 0.3s ease-in-out;
  display: ${({ $mode }) => ($mode ? 'block' : 'none')};

  left: ${({ $mode }) => {
    if ($mode === 'CALL') return '0';
    if ($mode === 'ARS') return 'calc(100% - 50%)';
    return '0';
  }};

  background: ${({ $mode }) => {
    if ($mode === 'CALL') return '#ff5722';
    if ($mode === 'ARS') return '#1677ff';
    return 'transparent';
  }};

  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
`;

const ToggleOption = styled.span<{ $isActive: boolean }>`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: ${({ $isActive }) => ($isActive ? '#fff' : '#888')};
  transition: all 0.3s ease-in-out;
  z-index: 1;
`;

const InboundToggleButton = () => {
  // ARS, 음성통화 상태값 받아오기
  const [inboundToggleS, setInboundToggleS] = useRecoilState(inboundToggleRecoil);

  const [isARS, setIsARS] = useState<'ARS' | 'CALL' | null>(null);

  const { data, isLoading, isError } = useQuery(['/v1/inbound-status'], () => getInboundStatus(), {
    onSuccess: (res) => setInboundToggleS(res.status),
    onError: () => setIsARS(null),
  });

  const { mutate } = useMutation(putInboundStatus);

  const onClickinBoundToggle = () => {
    mutate(undefined, {
      onSuccess: (data) => {
        setInboundToggleS(data.status);
      },
    });
  };

  useEffect(() => {
    if (inboundToggleS === 'ARS' || inboundToggleS === 'CALL') {
      setIsARS(inboundToggleS);
    } else {
      setIsARS(null);
    }
  }, [inboundToggleS]);

  return (
    <ToggleContainer onClick={() => onClickinBoundToggle()}>
      <ToggleOption $isActive={isARS === 'CALL'}>
        <PiPhoneCallThin size={22} color={isARS === 'CALL' ? '#fff' : '#888'} />
      </ToggleOption>
      <ToggleOption $isActive={isARS === 'ARS'}>
        <IoIosRecording size={22} color={isARS === 'ARS' ? '#fff' : '#888'} />
      </ToggleOption>
      <ToggleIndicator $mode={isARS} />
    </ToggleContainer>
  );
};

export default InboundToggleButton;
